import { QueryClientProvider, QueryClient } from "react-query";
import axios, { AxiosError } from "axios";
import { useToast } from "./ToastContext";
import { useAuth } from "./AuthContext";

const queryClient = new QueryClient();

export default function QueryClientContext({ children }: any) {
	const { handleToast } = useToast();
	const { handleLogout } = useAuth();

	queryClient.setDefaultOptions({
		queries: {
			onError: (error: unknown) => {
				if (axios.isAxiosError(error)) {
					const axiosError = error as AxiosError<any>;
					if (axiosError.response) {
						const status = axiosError.response.status;
						if (status === 400) {
							handleToast(null, "Erro 400: Solicitação inválida.", 5000, "danger");
						} else if (status === 401) {
							queryClient.invalidateQueries();
							handleToast(null, "Erro 401: Credenciais inválidas.", 5000, "danger");
							handleLogout();
						} else if (status === 404) {
							handleToast(null, "Erro 404: Recurso não encontrado.", 5000, "danger");
						} else {
							handleToast(null, `Erro ${status}: ${axiosError.response.data.message}`, 5000, "danger");
						}
					} else if (axiosError.request) {
						handleToast(null, "Nenhuma resposta recebida.", 5000, "danger");
					} else {
						handleToast(null, `Erro: ${axiosError.message}`, 5000, "danger");
					}
				} else {
					handleToast(null, `Erro desconhecido: ${error}`, 5000, "danger");
				}
			},
		},
	});

	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
